export const TEST_IDS = {
  timelineDivider: (id: string) => `timeline-divider-${id}`,
  timelineDividerConnector: 'timeline-divider-connector',
}
